import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import ClusterRespondentsValue from '../../../cluster-respondents-value/ClusterRespondentsValue';
import WithLabel from '../../../../../components/with-label/WithLabel';
import CommonDropdown from '../../../../../components/common-dropdown/CommonDropdown';
import CompareSection from './compare-section/CompareSection';
import useAudienceOptions from '../../hooks/useAudienceOptions';
import { useProject } from '../../../../../context/ProjectContext';
import useClusteredRespondents from '../../hooks/useClusteredRespondents';

import scss from './AudienceCorrelation.module.scss';

function AudienceCorrelation({ appliedFilters, selectedAudience, onSelectAudience, onApplyFilters }) {
  const { t } = useTranslation('resonance');
  const { id: projectId } = useParams();
  const { actions } = useProject();

  const audienceOptions = useAudienceOptions();
  const clusterRespondents = useClusteredRespondents();
  const isFiltersApplied = !!appliedFilters.length;

  const handleSelectAudience = (audience) => {
    onSelectAudience(audience);
    onApplyFilters([]);
  };

  useEffect(() => {
    if (!selectedAudience && audienceOptions.length) {
      onSelectAudience(audienceOptions[0].value);
    }
  }, [selectedAudience, audienceOptions, onSelectAudience]);

  useEffect(() => {
    if (selectedAudience) {
      actions('getResonanceBackgroundData', { projectId, audiences: appliedFilters, header: selectedAudience });
    }
  }, [appliedFilters, selectedAudience, actions, projectId]);

  return (
    <div className={scss.wrapper}>
      <div className={scss.filterWrapper}>
        <div>
          <ClusterRespondentsValue clusterRespondents={isFiltersApplied ? clusterRespondents : null} />
        </div>

        <WithLabel label={`${t('characteristic')}:`} isBold maxWidth={360}>
          <CommonDropdown
            options={audienceOptions}
            value={selectedAudience}
            onSelect={handleSelectAudience}
            isSearchable
            isFilterable
            isLoading={false}
          />
        </WithLabel>
      </div>

      <CompareSection selectedAudience={selectedAudience} isFiltersApplied={isFiltersApplied} />
    </div>
  );
}

export default AudienceCorrelation;
